import { render, staticRenderFns } from "./OpdrachtDeleteDialog.vue?vue&type=template&id=44d3b13f"
import script from "./OpdrachtDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./OpdrachtDeleteDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports